import React from "react";

import { Container, Navbar, Nav } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap'
import LogInbtn from "./LogInBtn";
import Image from "../images/logo_afp.png";

function NavBarEjecutivo() {

    return (
        <div>
            <Navbar className="navBarCustom" bg="light" expand="lg" >
                <Container>
                    <LinkContainer to='/'>
                        <Navbar.Brand ><img
                            alt=""
                            src={Image}
                            width="80"
                            height="37"
                            className="d-inline-block align-top text-center"
                        /></Navbar.Brand>
                    </LinkContainer>
                    <LinkContainer to='/'>
                        <Nav.Link>Home</Nav.Link>
                    </LinkContainer>
                    <LogInbtn/>
                </Container>
            </Navbar>
        </div>
    )
}

export default NavBarEjecutivo